import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search";
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import timestampCalculator from "shared/lib/timestampCalculator";
import useFetch from "shared/model/useFetch";

/**
 * @Desc 필기 결제 내역 Page
 * @Access 결제 내역 Page 권한 확인 필요
 * 사용자관리 ui 참고
 * 유저 IDX, 유저아이디, 유저닉네임, 유저이름, 유저연락처, 필기시험 종류, 필기시험상태, 결제금액, 결제날짜, 결제된 필기시험IDX
 *
 * 유저아이디가 빠져있습니다.
 * 필기시험상태 passed로 되어있는데 불합격시는 어떤 문자열을 주시나요?
 * 프론트에서 사용하지 않는 필드입니다.
 * data.current_page
 * data.total_count
 * data.writing_test_payment_history.payment_id
 * data.writing_test_payment_history.completion_date
 * data.writing_test_payment_history.date
 */
const TryoutWtPayList = () => {
  const navigate = useNavigate();

  const sizeList = [
    "short",
    "longlong",
    "long",
    "long",
    "long",
    "long",
    "long",
    "long",
    "long",
  ];
  const tableHeadList = [
    "ID",
    "아이디",
    "닉네임",
    "이름",
    "연락처",
    "필기시험 종류",
    "필기시험 상태",
    "결제 금액",
    "결제 날짜",
  ];

  const [fetchResult, fetchRequest] = useFetch();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const search = searchParams.get("search");

  useEffect(() => {
    let path = `/admin/exam-payment/writing/history?page=${page}`;
    if (search) path += `&search=${search}`;
    fetchRequest("GET", path);
  }, [page, search]);

  console.log(
    "🚀~fetchResult?.data?.writing_test_payment_history :",
    fetchResult?.data?.writing_test_payment_history
  );
  return (
    <Style.Wrapper>
      <MainHeader>필기 결제 내역</MainHeader>
      <Search placeholder="연락처에 또는 이름을 입력해주세요" />

      <TStyle.TableDiv>
        <TStyle.TableRow $title>
          {tableHeadList.map((elem, index) => (
            <TStyle.Data $title $size={sizeList[index]}>
              {elem}
            </TStyle.Data>
          ))}
        </TStyle.TableRow>
        {fetchResult?.data?.writing_test_payment_history?.map((elem, index) => (
          <TStyle.TableRow $odd={index % 2 === 1}>
            <TStyle.Data $size={sizeList[0]}>{elem?.payment_id}</TStyle.Data>
            <TStyle.Data
              $size={sizeList[1]}
              onClick={() => navigate(`/user/${elem?.account_idx}/detail`)}
            >
              {elem?.userid ?? "-"}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[2]}>{elem?.user_nickname}</TStyle.Data>
            <TStyle.Data $size={sizeList[3]}>{elem?.user_name}</TStyle.Data>
            <TStyle.Data $size={sizeList[4]}>
              +{elem?.international_number} {elem?.phone}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[5]}>{elem?.test_type}</TStyle.Data>
            <TStyle.Data $size={sizeList[6]}>
              {elem?.pass_status === "passed" && "합격"}
              {elem?.pass_status === "failed" && "불합격"}
              {elem?.pass_status === "pending" && "결제완료"}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[7]}>
              {elem?.amount.toLocaleString()}
            </TStyle.Data>
            <TStyle.Data $size={sizeList[8]}>
              {timestampCalculator(elem?.payment_date)}
            </TStyle.Data>
          </TStyle.TableRow>
        ))}
      </TStyle.TableDiv>

      <Pagenation maxPage={fetchResult?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default TryoutWtPayList;
